(function () {
  var CARD_SELECTOR = '.event-form-section__card';
  var SELECT_PLACEHOLDER = 'Select an option';

  /* Full ITU dial-code list (ISO 3166-1 alpha-2) — Shopify Forms parity */
  var COUNTRIES = [
    { iso: 'AF', name: 'Afghanistan', dial: '93', flag: '🇦🇫' },
    { iso: 'AL', name: 'Albania', dial: '355', flag: '🇦🇱' },
    { iso: 'DZ', name: 'Algeria', dial: '213', flag: '🇩🇿' },
    { iso: 'AS', name: 'American Samoa', dial: '1', flag: '🇦🇸' },
    { iso: 'AD', name: 'Andorra', dial: '376', flag: '🇦🇩' },
    { iso: 'AO', name: 'Angola', dial: '244', flag: '🇦🇴' },
    { iso: 'AI', name: 'Anguilla', dial: '1', flag: '🇦🇮' },
    { iso: 'AG', name: 'Antigua and Barbuda', dial: '1', flag: '🇦🇬' },
    { iso: 'AR', name: 'Argentina', dial: '54', flag: '🇦🇷' },
    { iso: 'AM', name: 'Armenia', dial: '374', flag: '🇦🇲' },
    { iso: 'AW', name: 'Aruba', dial: '297', flag: '🇦🇼' },
    { iso: 'AU', name: 'Australia', dial: '61', flag: '🇦🇺' },
    { iso: 'AT', name: 'Austria', dial: '43', flag: '🇦🇹' },
    { iso: 'AZ', name: 'Azerbaijan', dial: '994', flag: '🇦🇿' },
    { iso: 'BS', name: 'Bahamas', dial: '1', flag: '🇧🇸' },
    { iso: 'BH', name: 'Bahrain', dial: '973', flag: '🇧🇭' },
    { iso: 'BD', name: 'Bangladesh', dial: '880', flag: '🇧🇩' },
    { iso: 'BB', name: 'Barbados', dial: '1', flag: '🇧🇧' },
    { iso: 'BY', name: 'Belarus', dial: '375', flag: '🇧🇾' },
    { iso: 'BE', name: 'Belgium', dial: '32', flag: '🇧🇪' },
    { iso: 'BZ', name: 'Belize', dial: '501', flag: '🇧🇿' },
    { iso: 'BJ', name: 'Benin', dial: '229', flag: '🇧🇯' },
    { iso: 'BM', name: 'Bermuda', dial: '1', flag: '🇧🇲' },
    { iso: 'BT', name: 'Bhutan', dial: '975', flag: '🇧🇹' },
    { iso: 'BO', name: 'Bolivia', dial: '591', flag: '🇧🇴' },
    { iso: 'BA', name: 'Bosnia and Herzegovina', dial: '387', flag: '🇧🇦' },
    { iso: 'BW', name: 'Botswana', dial: '267', flag: '🇧🇼' },
    { iso: 'BR', name: 'Brazil', dial: '55', flag: '🇧🇷' },
    { iso: 'IO', name: 'British Indian Ocean Territory', dial: '246', flag: '🇮🇴' },
    { iso: 'VG', name: 'British Virgin Islands', dial: '1', flag: '🇻🇬' },
    { iso: 'BN', name: 'Brunei', dial: '673', flag: '🇧🇳' },
    { iso: 'BG', name: 'Bulgaria', dial: '359', flag: '🇧🇬' },
    { iso: 'BF', name: 'Burkina Faso', dial: '226', flag: '🇧🇫' },
    { iso: 'BI', name: 'Burundi', dial: '257', flag: '🇧🇮' },
    { iso: 'KH', name: 'Cambodia', dial: '855', flag: '🇰🇭' },
    { iso: 'CM', name: 'Cameroon', dial: '237', flag: '🇨🇲' },
    { iso: 'CA', name: 'Canada', dial: '1', flag: '🇨🇦' },
    { iso: 'CV', name: 'Cape Verde', dial: '238', flag: '🇨🇻' },
    { iso: 'KY', name: 'Cayman Islands', dial: '1', flag: '🇰🇾' },
    { iso: 'CF', name: 'Central African Republic', dial: '236', flag: '🇨🇫' },
    { iso: 'TD', name: 'Chad', dial: '235', flag: '🇹🇩' },
    { iso: 'CL', name: 'Chile', dial: '56', flag: '🇨🇱' },
    { iso: 'CN', name: 'China', dial: '86', flag: '🇨🇳' },
    { iso: 'CX', name: 'Christmas Island', dial: '61', flag: '🇨🇽' },
    { iso: 'CC', name: 'Cocos Islands', dial: '61', flag: '🇨🇨' },
    { iso: 'CO', name: 'Colombia', dial: '57', flag: '🇨🇴' },
    { iso: 'KM', name: 'Comoros', dial: '269', flag: '🇰🇲' },
    { iso: 'CK', name: 'Cook Islands', dial: '682', flag: '🇨🇰' },
    { iso: 'CR', name: 'Costa Rica', dial: '506', flag: '🇨🇷' },
    { iso: 'HR', name: 'Croatia', dial: '385', flag: '🇭🇷' },
    { iso: 'CU', name: 'Cuba', dial: '53', flag: '🇨🇺' },
    { iso: 'CW', name: 'Curaçao', dial: '599', flag: '🇨🇼' },
    { iso: 'CY', name: 'Cyprus', dial: '357', flag: '🇨🇾' },
    { iso: 'CZ', name: 'Czech Republic', dial: '420', flag: '🇨🇿' },
    { iso: 'CD', name: 'Democratic Republic of the Congo', dial: '243', flag: '🇨🇩' },
    { iso: 'DK', name: 'Denmark', dial: '45', flag: '🇩🇰' },
    { iso: 'DJ', name: 'Djibouti', dial: '253', flag: '🇩🇯' },
    { iso: 'DM', name: 'Dominica', dial: '1', flag: '🇩🇲' },
    { iso: 'DO', name: 'Dominican Republic', dial: '1', flag: '🇩🇴' },
    { iso: 'TL', name: 'East Timor', dial: '670', flag: '🇹🇱' },
    { iso: 'EC', name: 'Ecuador', dial: '593', flag: '🇪🇨' },
    { iso: 'EG', name: 'Egypt', dial: '20', flag: '🇪🇬' },
    { iso: 'SV', name: 'El Salvador', dial: '503', flag: '🇸🇻' },
    { iso: 'GQ', name: 'Equatorial Guinea', dial: '240', flag: '🇬🇶' },
    { iso: 'ER', name: 'Eritrea', dial: '291', flag: '🇪🇷' },
    { iso: 'EE', name: 'Estonia', dial: '372', flag: '🇪🇪' },
    { iso: 'SZ', name: 'Eswatini', dial: '268', flag: '🇸🇿' },
    { iso: 'ET', name: 'Ethiopia', dial: '251', flag: '🇪🇹' },
    { iso: 'FK', name: 'Falkland Islands', dial: '500', flag: '🇫🇰' },
    { iso: 'FO', name: 'Faroe Islands', dial: '298', flag: '🇫🇴' },
    { iso: 'FJ', name: 'Fiji', dial: '679', flag: '🇫🇯' },
    { iso: 'FI', name: 'Finland', dial: '358', flag: '🇫🇮' },
    { iso: 'FR', name: 'France', dial: '33', flag: '🇫🇷' },
    { iso: 'GF', name: 'French Guiana', dial: '594', flag: '🇬🇫' },
    { iso: 'PF', name: 'French Polynesia', dial: '689', flag: '🇵🇫' },
    { iso: 'GA', name: 'Gabon', dial: '241', flag: '🇬🇦' },
    { iso: 'GM', name: 'Gambia', dial: '220', flag: '🇬🇲' },
    { iso: 'GE', name: 'Georgia', dial: '995', flag: '🇬🇪' },
    { iso: 'DE', name: 'Germany', dial: '49', flag: '🇩🇪' },
    { iso: 'GH', name: 'Ghana', dial: '233', flag: '🇬🇭' },
    { iso: 'GI', name: 'Gibraltar', dial: '350', flag: '🇬🇮' },
    { iso: 'GR', name: 'Greece', dial: '30', flag: '🇬🇷' },
    { iso: 'GL', name: 'Greenland', dial: '299', flag: '🇬🇱' },
    { iso: 'GD', name: 'Grenada', dial: '1', flag: '🇬🇩' },
    { iso: 'GP', name: 'Guadeloupe', dial: '590', flag: '🇬🇵' },
    { iso: 'GU', name: 'Guam', dial: '1', flag: '🇬🇺' },
    { iso: 'GT', name: 'Guatemala', dial: '502', flag: '🇬🇹' },
    { iso: 'GG', name: 'Guernsey', dial: '44', flag: '🇬🇬' },
    { iso: 'GN', name: 'Guinea', dial: '224', flag: '🇬🇳' },
    { iso: 'GW', name: 'Guinea-Bissau', dial: '245', flag: '🇬🇼' },
    { iso: 'GY', name: 'Guyana', dial: '592', flag: '🇬🇾' },
    { iso: 'HT', name: 'Haiti', dial: '509', flag: '🇭🇹' },
    { iso: 'HN', name: 'Honduras', dial: '504', flag: '🇭🇳' },
    { iso: 'HK', name: 'Hong Kong', dial: '852', flag: '🇭🇰' },
    { iso: 'HU', name: 'Hungary', dial: '36', flag: '🇭🇺' },
    { iso: 'IS', name: 'Iceland', dial: '354', flag: '🇮🇸' },
    { iso: 'IN', name: 'India', dial: '91', flag: '🇮🇳' },
    { iso: 'ID', name: 'Indonesia', dial: '62', flag: '🇮🇩' },
    { iso: 'IR', name: 'Iran', dial: '98', flag: '🇮🇷' },
    { iso: 'IQ', name: 'Iraq', dial: '964', flag: '🇮🇶' },
    { iso: 'IE', name: 'Ireland', dial: '353', flag: '🇮🇪' },
    { iso: 'IM', name: 'Isle of Man', dial: '44', flag: '🇮🇲' },
    { iso: 'IL', name: 'Israel', dial: '972', flag: '🇮🇱' },
    { iso: 'IT', name: 'Italy', dial: '39', flag: '🇮🇹' },
    { iso: 'CI', name: 'Ivory Coast', dial: '225', flag: '🇨🇮' },
    { iso: 'JM', name: 'Jamaica', dial: '1', flag: '🇯🇲' },
    { iso: 'JP', name: 'Japan', dial: '81', flag: '🇯🇵' },
    { iso: 'JE', name: 'Jersey', dial: '44', flag: '🇯🇪' },
    { iso: 'JO', name: 'Jordan', dial: '962', flag: '🇯🇴' },
    { iso: 'KZ', name: 'Kazakhstan', dial: '7', flag: '🇰🇿' },
    { iso: 'KE', name: 'Kenya', dial: '254', flag: '🇰🇪' },
    { iso: 'KI', name: 'Kiribati', dial: '686', flag: '🇰🇮' },
    { iso: 'XK', name: 'Kosovo', dial: '383', flag: '🇽🇰' },
    { iso: 'KW', name: 'Kuwait', dial: '965', flag: '🇰🇼' },
    { iso: 'KG', name: 'Kyrgyzstan', dial: '996', flag: '🇰🇬' },
    { iso: 'LA', name: 'Laos', dial: '856', flag: '🇱🇦' },
    { iso: 'LV', name: 'Latvia', dial: '371', flag: '🇱🇻' },
    { iso: 'LB', name: 'Lebanon', dial: '961', flag: '🇱🇧' },
    { iso: 'LS', name: 'Lesotho', dial: '266', flag: '🇱🇸' },
    { iso: 'LR', name: 'Liberia', dial: '231', flag: '🇱🇷' },
    { iso: 'LY', name: 'Libya', dial: '218', flag: '🇱🇾' },
    { iso: 'LI', name: 'Liechtenstein', dial: '423', flag: '🇱🇮' },
    { iso: 'LT', name: 'Lithuania', dial: '370', flag: '🇱🇹' },
    { iso: 'LU', name: 'Luxembourg', dial: '352', flag: '🇱🇺' },
    { iso: 'MO', name: 'Macau', dial: '853', flag: '🇲🇴' },
    { iso: 'MG', name: 'Madagascar', dial: '261', flag: '🇲🇬' },
    { iso: 'MW', name: 'Malawi', dial: '265', flag: '🇲🇼' },
    { iso: 'MY', name: 'Malaysia', dial: '60', flag: '🇲🇾' },
    { iso: 'MV', name: 'Maldives', dial: '960', flag: '🇲🇻' },
    { iso: 'ML', name: 'Mali', dial: '223', flag: '🇲🇱' },
    { iso: 'MT', name: 'Malta', dial: '356', flag: '🇲🇹' },
    { iso: 'MH', name: 'Marshall Islands', dial: '692', flag: '🇲🇭' },
    { iso: 'MQ', name: 'Martinique', dial: '596', flag: '🇲🇶' },
    { iso: 'MR', name: 'Mauritania', dial: '222', flag: '🇲🇷' },
    { iso: 'MU', name: 'Mauritius', dial: '230', flag: '🇲🇺' },
    { iso: 'YT', name: 'Mayotte', dial: '262', flag: '🇾🇹' },
    { iso: 'MX', name: 'Mexico', dial: '52', flag: '🇲🇽' },
    { iso: 'FM', name: 'Micronesia', dial: '691', flag: '🇫🇲' },
    { iso: 'MD', name: 'Moldova', dial: '373', flag: '🇲🇩' },
    { iso: 'MC', name: 'Monaco', dial: '377', flag: '🇲🇨' },
    { iso: 'MN', name: 'Mongolia', dial: '976', flag: '🇲🇳' },
    { iso: 'ME', name: 'Montenegro', dial: '382', flag: '🇲🇪' },
    { iso: 'MS', name: 'Montserrat', dial: '1', flag: '🇲🇸' },
    { iso: 'MA', name: 'Morocco', dial: '212', flag: '🇲🇦' },
    { iso: 'MZ', name: 'Mozambique', dial: '258', flag: '🇲🇿' },
    { iso: 'MM', name: 'Myanmar', dial: '95', flag: '🇲🇲' },
    { iso: 'NA', name: 'Namibia', dial: '264', flag: '🇳🇦' },
    { iso: 'NR', name: 'Nauru', dial: '674', flag: '🇳🇷' },
    { iso: 'NP', name: 'Nepal', dial: '977', flag: '🇳🇵' },
    { iso: 'NL', name: 'Netherlands', dial: '31', flag: '🇳🇱' },
    { iso: 'NC', name: 'New Caledonia', dial: '687', flag: '🇳🇨' },
    { iso: 'NZ', name: 'New Zealand', dial: '64', flag: '🇳🇿' },
    { iso: 'NI', name: 'Nicaragua', dial: '505', flag: '🇳🇮' },
    { iso: 'NE', name: 'Niger', dial: '227', flag: '🇳🇪' },
    { iso: 'NG', name: 'Nigeria', dial: '234', flag: '🇳🇬' },
    { iso: 'NU', name: 'Niue', dial: '683', flag: '🇳🇺' },
    { iso: 'NF', name: 'Norfolk Island', dial: '672', flag: '🇳🇫' },
    { iso: 'KP', name: 'North Korea', dial: '850', flag: '🇰🇵' },
    { iso: 'MK', name: 'North Macedonia', dial: '389', flag: '🇲🇰' },
    { iso: 'MP', name: 'Northern Mariana Islands', dial: '1', flag: '🇲🇵' },
    { iso: 'NO', name: 'Norway', dial: '47', flag: '🇳🇴' },
    { iso: 'OM', name: 'Oman', dial: '968', flag: '🇴🇲' },
    { iso: 'PK', name: 'Pakistan', dial: '92', flag: '🇵🇰' },
    { iso: 'PW', name: 'Palau', dial: '680', flag: '🇵🇼' },
    { iso: 'PS', name: 'Palestine', dial: '970', flag: '🇵🇸' },
    { iso: 'PA', name: 'Panama', dial: '507', flag: '🇵🇦' },
    { iso: 'PG', name: 'Papua New Guinea', dial: '675', flag: '🇵🇬' },
    { iso: 'PY', name: 'Paraguay', dial: '595', flag: '🇵🇾' },
    { iso: 'PE', name: 'Peru', dial: '51', flag: '🇵🇪' },
    { iso: 'PH', name: 'Philippines', dial: '63', flag: '🇵🇭' },
    { iso: 'PL', name: 'Poland', dial: '48', flag: '🇵🇱' },
    { iso: 'PT', name: 'Portugal', dial: '351', flag: '🇵🇹' },
    { iso: 'PR', name: 'Puerto Rico', dial: '1', flag: '🇵🇷' },
    { iso: 'QA', name: 'Qatar', dial: '974', flag: '🇶🇦' },
    { iso: 'CG', name: 'Republic of the Congo', dial: '242', flag: '🇨🇬' },
    { iso: 'RE', name: 'Réunion', dial: '262', flag: '🇷🇪' },
    { iso: 'RO', name: 'Romania', dial: '40', flag: '🇷🇴' },
    { iso: 'RU', name: 'Russia', dial: '7', flag: '🇷🇺' },
    { iso: 'RW', name: 'Rwanda', dial: '250', flag: '🇷🇼' },
    { iso: 'BL', name: 'Saint Barthélemy', dial: '590', flag: '🇧🇱' },
    { iso: 'SH', name: 'Saint Helena', dial: '290', flag: '🇸🇭' },
    { iso: 'KN', name: 'Saint Kitts and Nevis', dial: '1', flag: '🇰🇳' },
    { iso: 'LC', name: 'Saint Lucia', dial: '1', flag: '🇱🇨' },
    { iso: 'MF', name: 'Saint Martin', dial: '590', flag: '🇲🇫' },
    { iso: 'PM', name: 'Saint Pierre and Miquelon', dial: '508', flag: '🇵🇲' },
    { iso: 'VC', name: 'Saint Vincent and the Grenadines', dial: '1', flag: '🇻🇨' },
    { iso: 'WS', name: 'Samoa', dial: '685', flag: '🇼🇸' },
    { iso: 'SM', name: 'San Marino', dial: '378', flag: '🇸🇲' },
    { iso: 'ST', name: 'São Tomé and Príncipe', dial: '239', flag: '🇸🇹' },
    { iso: 'SA', name: 'Saudi Arabia', dial: '966', flag: '🇸🇦' },
    { iso: 'SN', name: 'Senegal', dial: '221', flag: '🇸🇳' },
    { iso: 'RS', name: 'Serbia', dial: '381', flag: '🇷🇸' },
    { iso: 'SC', name: 'Seychelles', dial: '248', flag: '🇸🇨' },
    { iso: 'SL', name: 'Sierra Leone', dial: '232', flag: '🇸🇱' },
    { iso: 'SG', name: 'Singapore', dial: '65', flag: '🇸🇬' },
    { iso: 'SX', name: 'Sint Maarten', dial: '1', flag: '🇸🇽' },
    { iso: 'SK', name: 'Slovakia', dial: '421', flag: '🇸🇰' },
    { iso: 'SI', name: 'Slovenia', dial: '386', flag: '🇸🇮' },
    { iso: 'SB', name: 'Solomon Islands', dial: '677', flag: '🇸🇧' },
    { iso: 'SO', name: 'Somalia', dial: '252', flag: '🇸🇴' },
    { iso: 'ZA', name: 'South Africa', dial: '27', flag: '🇿🇦' },
    { iso: 'KR', name: 'South Korea', dial: '82', flag: '🇰🇷' },
    { iso: 'SS', name: 'South Sudan', dial: '211', flag: '🇸🇸' },
    { iso: 'ES', name: 'Spain', dial: '34', flag: '🇪🇸' },
    { iso: 'LK', name: 'Sri Lanka', dial: '94', flag: '🇱🇰' },
    { iso: 'SD', name: 'Sudan', dial: '249', flag: '🇸🇩' },
    { iso: 'SR', name: 'Suriname', dial: '597', flag: '🇸🇷' },
    { iso: 'SJ', name: 'Svalbard and Jan Mayen', dial: '47', flag: '🇸🇯' },
    { iso: 'SE', name: 'Sweden', dial: '46', flag: '🇸🇪' },
    { iso: 'CH', name: 'Switzerland', dial: '41', flag: '🇨🇭' },
    { iso: 'SY', name: 'Syria', dial: '963', flag: '🇸🇾' },
    { iso: 'TW', name: 'Taiwan', dial: '886', flag: '🇹🇼' },
    { iso: 'TJ', name: 'Tajikistan', dial: '992', flag: '🇹🇯' },
    { iso: 'TZ', name: 'Tanzania', dial: '255', flag: '🇹🇿' },
    { iso: 'TH', name: 'Thailand', dial: '66', flag: '🇹🇭' },
    { iso: 'TG', name: 'Togo', dial: '228', flag: '🇹🇬' },
    { iso: 'TK', name: 'Tokelau', dial: '690', flag: '🇹🇰' },
    { iso: 'TO', name: 'Tonga', dial: '676', flag: '🇹🇴' },
    { iso: 'TT', name: 'Trinidad and Tobago', dial: '1', flag: '🇹🇹' },
    { iso: 'TN', name: 'Tunisia', dial: '216', flag: '🇹🇳' },
    { iso: 'TR', name: 'Turkey', dial: '90', flag: '🇹🇷' },
    { iso: 'TM', name: 'Turkmenistan', dial: '993', flag: '🇹🇲' },
    { iso: 'TC', name: 'Turks and Caicos Islands', dial: '1', flag: '🇹🇨' },
    { iso: 'TV', name: 'Tuvalu', dial: '688', flag: '🇹🇻' },
    { iso: 'VI', name: 'U.S. Virgin Islands', dial: '1', flag: '🇻🇮' },
    { iso: 'UG', name: 'Uganda', dial: '256', flag: '🇺🇬' },
    { iso: 'UA', name: 'Ukraine', dial: '380', flag: '🇺🇦' },
    { iso: 'AE', name: 'United Arab Emirates', dial: '971', flag: '🇦🇪' },
    { iso: 'GB', name: 'United Kingdom', dial: '44', flag: '🇬🇧' },
    { iso: 'US', name: 'United States', dial: '1', flag: '🇺🇸' },
    { iso: 'UY', name: 'Uruguay', dial: '598', flag: '🇺🇾' },
    { iso: 'UZ', name: 'Uzbekistan', dial: '998', flag: '🇺🇿' },
    { iso: 'VU', name: 'Vanuatu', dial: '678', flag: '🇻🇺' },
    { iso: 'VA', name: 'Vatican City', dial: '39', flag: '🇻🇦' },
    { iso: 'VE', name: 'Venezuela', dial: '58', flag: '🇻🇪' },
    { iso: 'VN', name: 'Vietnam', dial: '84', flag: '🇻🇳' },
    { iso: 'WF', name: 'Wallis and Futuna', dial: '681', flag: '🇼🇫' },
    { iso: 'EH', name: 'Western Sahara', dial: '212', flag: '🇪🇭' },
    { iso: 'YE', name: 'Yemen', dial: '967', flag: '🇾🇪' },
    { iso: 'ZM', name: 'Zambia', dial: '260', flag: '🇿🇲' },
    { iso: 'ZW', name: 'Zimbabwe', dial: '263', flag: '🇿🇼' }
  ];

  var PLACEHOLDER_BY_NAME = {
    name: 'Full name',
    email: 'Email',
    phone: 'Phone',
    company: 'Company name',
    company_name: 'Company name',
    city: 'City / State',
    city_state: 'City / State',
    enter_number_of_guests_minimum_8_required: 'Enter number of guests (minimum 8 required)',
    preferred_date: 'Preferred date',
    tell_us_your_preferred_location_details_any_special_requests_or_:
      'Tell us your preferred location details, any special requests, or questions you have.',
    tell_us_any_additional_details_or_questions_you_have:
      'Tell us any additional details or questions you have.'
  };

  function findCountry(iso) {
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (COUNTRIES[i].iso === iso) return COUNTRIES[i];
    }
    return findCountry('US');
  }

  function defaultIso(block) {
    var fromBlock = String((block && block.getAttribute('data-country')) || '')
      .trim()
      .toUpperCase();
    if (fromBlock) {
      for (var i = 0; i < COUNTRIES.length; i++) {
        if (COUNTRIES[i].iso === fromBlock) return fromBlock;
      }
    }
    var lang = (navigator.language || '').toUpperCase();
    if (lang.indexOf('-') > -1) {
      var region = lang.split('-').pop();
      for (var j = 0; j < COUNTRIES.length; j++) {
        if (COUNTRIES[j].iso === region) return region;
      }
    }
    return 'US';
  }

  function labelText(label) {
    var span = label.querySelector(':scope > span, span');
    return ((span && span.textContent) || '').replace(/\*/g, '').trim();
  }

  var HIDE_LABEL_NAMES = {
    name: 1,
    email: 1,
    enter_number_of_guests_minimum_8_required: 1,
    tell_us_your_preferred_location_details_any_special_requests_or_: 1,
    tell_us_any_additional_details_or_questions_you_have: 1
  };

  function enhancePlaceholders(label) {
    if (label.dataset.eventPhEnhanced === '1') return;
    var text = labelText(label);
    var select = label.querySelector('select:not(.event-form-phone__select)');
    if (select) {
      var first = select.options && select.options[0];
      if (first && (!first.value || first.value === '')) {
        first.textContent = SELECT_PLACEHOLDER;
      }
      label.dataset.eventPhEnhanced = '1';
      return;
    }

    var field = label.querySelector(
      'input:not([type="hidden"]):not([type="tel"]):not([type="date"]):not(.aogen-forms-hp):not(.event-form-date__part):not(.event-form-phone__input), textarea'
    );
    if (!field) return;
    if (!(field.placeholder && field.placeholder.trim())) {
      var mapped = PLACEHOLDER_BY_NAME[field.name] || text;
      if (mapped) field.setAttribute('placeholder', mapped);
    }
    if (HIDE_LABEL_NAMES[field.name]) {
      var span = label.querySelector(':scope > span, span');
      if (span) {
        span.setAttribute('hidden', '');
        span.classList.add('event-form-label-hidden');
      }
      if (!field.getAttribute('aria-label') && text) {
        field.setAttribute('aria-label', text);
      }
      label.classList.add('event-form-label--placeholder-only');
    }
    label.dataset.eventPhEnhanced = '1';
  }

  var CORPORATE_VISIBLE_LABELS = {
    email: 'Contact Person Email',
    name: 'Contact Person Name',
    guests: 'How many people',
    notes: 'Notes'
  };

  function showLabelOnWrap(wrap, title) {
    var label = wrap.querySelector('label');
    if (!label) return;
    var span = label.querySelector(':scope > span, span');
    if (!span) {
      span = document.createElement('span');
      label.insertBefore(span, label.firstChild);
    }
    span.textContent = title;
    span.removeAttribute('hidden');
    span.classList.remove('event-form-label-hidden');
    label.classList.remove('event-form-label--placeholder-only');
  }

  function applyCorporateVisibleLabels(card) {
    if (!card.closest('.section-cpe-events-form')) return;
    card.querySelectorAll('.event-form-field').forEach(function (wrap) {
      var key = corporateFieldKey(wrap);
      var title = CORPORATE_VISIBLE_LABELS[key];
      if (title) showLabelOnWrap(wrap, title);
    });
  }

  var PRIVATE_VISIBLE_LABELS = {
    email: 'Contact Person Email',
    name: 'Contact Person Name',
    guests: 'How many people',
    notes: 'Notes'
  };

  function applyPrivateVisibleLabels(card) {
    if (!card.closest('.section-pge-events-form')) return;
    card.querySelectorAll('.event-form-field').forEach(function (wrap) {
      var key = privateFieldKey(wrap);
      var title = PRIVATE_VISIBLE_LABELS[key];
      if (title) showLabelOnWrap(wrap, title);
    });
  }

  var phoneCountryOpen = null;

  function closePhoneCountry() {
    if (!phoneCountryOpen) return;
    phoneCountryOpen.classList.remove('is-open');
    var btn = phoneCountryOpen.querySelector('.event-form-phone__country');
    var list =
      document.querySelector('body > .event-form-phone__list') ||
      phoneCountryOpen.querySelector('.event-form-phone__list');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (list) {
      list.hidden = true;
      if (list.parentNode === document.body && phoneCountryOpen.isConnected) {
        phoneCountryOpen.appendChild(list);
      }
    }
    phoneCountryOpen = null;
  }

  function positionPhoneList(wrap, list) {
    var btn = wrap.querySelector('.event-form-phone__country');
    if (!btn) return;
    var r = btn.getBoundingClientRect();
    list.style.position = 'fixed';
    list.style.left = Math.max(8, r.left) + 'px';
    list.style.top = r.bottom + 4 + 'px';
    list.style.width = Math.max(260, r.width) + 'px';
    list.style.zIndex = '10060';
    list.style.maxHeight = Math.min(280, Math.max(160, window.innerHeight - r.bottom - 16)) + 'px';
  }

  function enhancePhone(label, block) {
    var input = label.querySelector('input[type="tel"]');
    if (!input || input.dataset.eventPhoneEnhanced === '1') return;
    if (label.querySelector('.event-form-phone')) return;

    input.dataset.eventPhoneEnhanced = '1';
    input.classList.add('event-form-phone__input');
    input.setAttribute('placeholder', 'Phone');
    input.setAttribute('autocomplete', 'tel-national');

    var wrap = document.createElement('div');
    wrap.className = 'event-form-phone';
    wrap.dataset.phoneIso = defaultIso(block);

    var countryWrap = document.createElement('div');
    countryWrap.className = 'event-form-phone__country-wrap';

    var countryBtn = document.createElement('button');
    countryBtn.type = 'button';
    countryBtn.className = 'event-form-phone__country';
    countryBtn.setAttribute('aria-label', 'Country code');
    countryBtn.setAttribute('aria-haspopup', 'listbox');
    countryBtn.setAttribute('aria-expanded', 'false');

    var list = document.createElement('ul');
    list.className = 'event-form-phone__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    COUNTRIES.forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'event-form-phone__option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-iso', c.iso);
      li.innerHTML =
        '<span class="event-form-phone__option-flag">' +
        c.flag +
        '</span><span class="event-form-phone__option-name">' +
        c.name +
        '</span><span class="event-form-phone__option-dial">+' +
        c.dial +
        '</span>';
      list.appendChild(li);
    });

    var numberWrap = document.createElement('div');
    numberWrap.className = 'event-form-phone__number';

    var prefix = document.createElement('span');
    prefix.className = 'event-form-phone__prefix';
    prefix.setAttribute('aria-hidden', 'true');

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = input.name;
    hidden.className = 'event-form-phone__value';

    var wasRequired = input.required;
    input.removeAttribute('name');
    if (wasRequired) input.required = true;

    function sync() {
      var c = findCountry(wrap.dataset.phoneIso);
      wrap.dataset.phoneIso = c.iso;
      countryBtn.innerHTML =
        '<span class="event-form-phone__flag">' +
        c.flag +
        '</span><span class="event-form-phone__chevron"></span>';
      prefix.textContent = '+' + c.dial;
      list.querySelectorAll('.event-form-phone__option').forEach(function (el) {
        el.setAttribute('aria-selected', el.getAttribute('data-iso') === c.iso ? 'true' : 'false');
      });
      var digits = String(input.value || '').replace(/\D+/g, '');
      if (digits.indexOf(c.dial) === 0 && digits.length > c.dial.length + 3) {
        digits = digits.slice(c.dial.length);
        input.value = digits;
      }
      hidden.value = digits ? '+' + c.dial + digits : '';
      if (digits) input.setCustomValidity('');
    }

    function setOpen(open) {
      if (open) {
        if (phoneCountryOpen && phoneCountryOpen !== countryWrap) closePhoneCountry();
        countryWrap.classList.add('is-open');
        countryBtn.setAttribute('aria-expanded', 'true');
        if (list.parentNode !== document.body) document.body.appendChild(list);
        list.hidden = false;
        positionPhoneList(countryWrap, list);
        phoneCountryOpen = countryWrap;
        var active = list.querySelector('.event-form-phone__option[aria-selected="true"]');
        if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
      } else if (phoneCountryOpen === countryWrap) {
        closePhoneCountry();
      }
    }

    countryBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(!countryWrap.classList.contains('is-open'));
    });

    list.addEventListener('click', function (e) {
      var li = e.target.closest('.event-form-phone__option');
      if (!li) return;
      e.preventDefault();
      e.stopPropagation();
      wrap.dataset.phoneIso = li.getAttribute('data-iso');
      sync();
      setOpen(false);
      input.focus();
    });

    input.addEventListener('input', sync);
    input.addEventListener('blur', sync);

    var form = input.closest('form');
    if (form && !form.dataset.eventPhoneSubmitBound) {
      form.dataset.eventPhoneSubmitBound = '1';
      form.addEventListener(
        'submit',
        function () {
          form.querySelectorAll('.event-form-phone').forEach(function (row) {
            var visible = row.querySelector('.event-form-phone__input');
            var valueEl = row.querySelector('.event-form-phone__value');
            var dialEl = row.querySelector('.event-form-phone__prefix');
            if (!visible || !valueEl) return;
            var dial = (dialEl && dialEl.textContent) || '';
            var digits = String(visible.value || '').replace(/\D+/g, '');
            valueEl.value = digits ? dial + digits : '';
            if (visible.required && !digits) {
              visible.setCustomValidity('Please enter a phone number');
            } else {
              visible.setCustomValidity('');
            }
          });
        },
        true
      );
    }

    if (!document.documentElement.dataset.eventPhoneCountryDoc) {
      document.documentElement.dataset.eventPhoneCountryDoc = '1';
      document.addEventListener(
        'pointerdown',
        function (e) {
          if (!phoneCountryOpen) return;
          var listEl = phoneCountryOpen.querySelector('.event-form-phone__list');
          if (listEl && listEl.parentNode === document.body) {
            /* list portaled — check separately */
          }
          var t = e.target;
          if (t && t.nodeType !== 1) t = t.parentElement;
          if (t && phoneCountryOpen.contains(t)) return;
          if (t && t.closest && t.closest('.event-form-phone__list')) return;
          closePhoneCountry();
        },
        true
      );
      window.addEventListener(
        'resize',
        function () {
          if (!phoneCountryOpen) return;
          var listEl = document.querySelector('body > .event-form-phone__list:not([hidden])');
          if (listEl) positionPhoneList(phoneCountryOpen, listEl);
        },
        { passive: true }
      );
    }

    input.parentNode.insertBefore(wrap, input);
    countryWrap.appendChild(countryBtn);
    countryWrap.appendChild(list);
    wrap.appendChild(countryWrap);
    numberWrap.appendChild(prefix);
    numberWrap.appendChild(input);
    wrap.appendChild(numberWrap);
    wrap.appendChild(hidden);
    sync();
  }

  function enhanceDate(label) {
    var input = label.querySelector('input[type="date"]');
    if (!input || input.dataset.eventDateEnhanced === '1') return;
    if (label.querySelector('.event-form-date')) return;

    input.dataset.eventDateEnhanced = '1';
    input.classList.add('event-form-date__native');
    input.tabIndex = -1;
    input.setAttribute('aria-hidden', 'true');
    input.required = false;

    var wrap = document.createElement('div');
    wrap.className = 'event-form-date';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Preferred Date');

    function makePart(ph, maxLen, className) {
      var el = document.createElement('input');
      el.type = 'text';
      el.inputMode = 'numeric';
      el.autocomplete = 'off';
      el.placeholder = ph;
      el.maxLength = maxLen;
      el.className = 'event-form-date__part ' + className;
      el.setAttribute('aria-label', ph);
      return el;
    }

    var mm = makePart('MM', 2, 'event-form-date__mm');
    var dd = makePart('DD', 2, 'event-form-date__dd');
    var yyyy = makePart('YYYY', 4, 'event-form-date__yyyy');

    function pad(v, n) {
      v = String(v || '').replace(/\D+/g, '');
      while (v.length < n) v = '0' + v;
      return v.slice(0, n);
    }

    function syncNative() {
      var m = mm.value.replace(/\D+/g, '');
      var d = dd.value.replace(/\D+/g, '');
      var y = yyyy.value.replace(/\D+/g, '');
      if (m.length === 2 && d.length === 2 && y.length === 4) {
        input.value = y + '-' + pad(m, 2) + '-' + pad(d, 2);
      } else {
        input.value = '';
      }
    }

    function onPartInput(el, next, len) {
      el.addEventListener('input', function () {
        el.value = el.value.replace(/\D+/g, '').slice(0, len);
        if (el.value.length >= len && next) next.focus();
        syncNative();
      });
    }

    onPartInput(dd, mm, 2);
    onPartInput(mm, yyyy, 2);
    onPartInput(yyyy, null, 4);

    if (input.value && /^\d{4}-\d{2}-\d{2}$/.test(input.value)) {
      var parts = input.value.split('-');
      yyyy.value = parts[0];
      mm.value = parts[1];
      dd.value = parts[2];
    }

    var form = input.closest('form');
    if (form && !form.dataset.eventDateSubmitBound) {
      form.dataset.eventDateSubmitBound = '1';
      form.addEventListener(
        'submit',
        function () {
          form.querySelectorAll('.event-form-date').forEach(function (row) {
            var native = row.parentNode.querySelector('input[type="date"].event-form-date__native');
            if (!native) return;
            var m = row.querySelector('.event-form-date__mm');
            var d = row.querySelector('.event-form-date__dd');
            var y = row.querySelector('.event-form-date__yyyy');
            if (!m || !d || !y) return;
            if (m.value && d.value && y.value && y.value.length === 4) {
              native.value = y.value + '-' + pad(m.value, 2) + '-' + pad(d.value, 2);
              native.setCustomValidity('');
            } else {
              native.value = '';
              native.setCustomValidity('Please enter a preferred date');
              d.focus();
            }
          });
        },
        true
      );
    }

    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(dd);
    wrap.appendChild(mm);
    wrap.appendChild(yyyy);
  }

  function groupFieldsForGrid(card) {
    var fields = card.querySelector('.aogen-forms-fields');
    if (!fields) return;

    /* Late amc-select siblings → pull into already-wrapped field */
    Array.prototype.slice
      .call(fields.querySelectorAll(':scope > .amc-select'))
      .forEach(function (selRoot) {
        var prev = selRoot.previousElementSibling;
        if (
          prev &&
          prev.classList.contains('event-form-field') &&
          !prev.querySelector('.amc-select')
        ) {
          prev.appendChild(selRoot);
        }
      });

    if (fields.dataset.efGrid === '1') return;

    var bareLabels = Array.prototype.slice.call(
      fields.querySelectorAll(':scope > label')
    );
    if (!bareLabels.length) return;

    fields.dataset.efGrid = '1';

    bareLabels.forEach(function (label) {
      if (label.parentElement !== fields) return;
      var wrap = document.createElement('div');
      wrap.className = 'event-form-field';
      fields.insertBefore(wrap, label);
      wrap.appendChild(label);
      var next = wrap.nextElementSibling;
      if (next && next.classList.contains('amc-select')) {
        wrap.appendChild(next);
      }
    });

    if (card.closest('.section-cpe-events-form')) {
      reorderCorporateFields(fields);
      applyCorporateVisibleLabels(card);
      return;
    }

    if (card.closest('.section-pge-events-form')) {
      reorderPrivateFields(fields);
      applyPrivateVisibleLabels(card);
    }
  }

  function applyFieldOrder(fields, keyFn, orderKeys) {
    var map = {};
    Array.prototype.slice
      .call(fields.querySelectorAll(':scope > .event-form-field'))
      .forEach(function (w) {
        var key = keyFn(w);
        if (key && !map[key]) map[key] = w;
      });

    var desired = [];
    orderKeys.forEach(function (key) {
      if (map[key]) desired.push(map[key]);
    });
    Array.prototype.slice
      .call(fields.querySelectorAll(':scope > .event-form-field'))
      .forEach(function (w) {
        if (desired.indexOf(w) === -1) desired.push(w);
      });

    var current = Array.prototype.slice.call(
      fields.querySelectorAll(':scope > .event-form-field')
    );
    var same =
      current.length === desired.length &&
      desired.every(function (w, i) {
        return w === current[i];
      });
    if (same) return map;

    desired.forEach(function (w) {
      fields.appendChild(w);
    });
    return map;
  }

  function privateFieldKey(wrap) {
    if (wrap.querySelector('textarea')) return 'notes';
    if (wrap.querySelector('.event-form-phone, input[type="tel"]')) return 'phone';
    if (wrap.querySelector('input[type="email"]')) return 'email';
    if (wrap.querySelector('.event-form-date, input[type="date"]')) return 'date';
    var span = wrap.querySelector('label span');
    var input = wrap.querySelector('input:not([type="hidden"])');
    var text = (
      ((span && span.textContent) || '') +
      ' ' +
      ((input && input.placeholder) || '')
    ).toLowerCase();
    if (wrap.querySelector('select')) {
      if (text.indexOf('location') !== -1) return 'location';
      return 'eventType';
    }
    if (text.indexOf('guest') !== -1) return 'guests';
    if (text.indexOf('full name') !== -1 || text.indexOf('name') !== -1) return 'name';
    return '';
  }

  function reorderPrivateFields(fields) {
    /*
      L | R
      Event Type | Location
      Guests | Full name
      Preferred Date | Phone
      Notes | Email
    */
    applyFieldOrder(fields, privateFieldKey, [
      'eventType',
      'location',
      'guests',
      'name',
      'date',
      'phone',
      'notes',
      'email'
    ]);
  }

  function corporateFieldKey(wrap) {
    if (wrap.querySelector('textarea')) return 'notes';
    if (wrap.querySelector('.event-form-phone, input[type="tel"]')) return 'phone';
    if (wrap.querySelector('input[type="email"]')) return 'email';
    if (wrap.querySelector('.event-form-date, input[type="date"]')) return 'date';
    if (wrap.querySelector('select')) return 'venue';
    var span = wrap.querySelector('label span');
    var input = wrap.querySelector('input:not([type="hidden"])');
    var text = (
      ((span && span.textContent) || '') +
      ' ' +
      ((input && input.placeholder) || '')
    ).toLowerCase();
    if (text.indexOf('company') !== -1) return 'company';
    if (text.indexOf('guest') !== -1) return 'guests';
    if (text.indexOf('city') !== -1 || text.indexOf('state') !== -1) return 'city';
    if (text.indexOf('full name') !== -1 || text.indexOf('contact person') !== -1) {
      return 'name';
    }
    return '';
  }

  function reorderCorporateFields(fields) {
    /*
      L | R
      City | Email
      Company | Full name
      Guests | Phone
      Date | Notes
      Venue (full width)
    */
    /*
      Locked layout:
      City | Email
      Company | Full name
      Guests | Phone
      Venue | Notes (notes spans 2 rows)
      Date  | Notes
    */
    var map = applyFieldOrder(fields, corporateFieldKey, [
      'city',
      'email',
      'company',
      'name',
      'guests',
      'phone',
      'venue',
      'notes',
      'date'
    ]);

    fields.querySelectorAll('.event-form-field--notes').forEach(function (el) {
      el.classList.remove('event-form-field--notes');
    });
    fields.querySelectorAll('.event-form-field--spacer').forEach(function (el) {
      el.remove();
    });
    if (map.notes) map.notes.classList.add('event-form-field--notes');
  }

  var processScheduled = false;
  var processRunning = false;

  function processCards() {
    if (processRunning) return;
    processRunning = true;
    try {
      document.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
        var block = card.querySelector('.aogen-forms-block');
        card.querySelectorAll('.aogen-forms-fields label').forEach(function (label) {
          enhancePlaceholders(label);
          if (label.querySelector('input[type="tel"]')) enhancePhone(label, block);
          if (label.querySelector('input[type="date"]')) enhanceDate(label);
        });
        groupFieldsForGrid(card);
      });
    } finally {
      processRunning = false;
    }
  }

  function scheduleProcess() {
    if (processScheduled || processRunning) return;
    processScheduled = true;
    requestAnimationFrame(function () {
      processScheduled = false;
      processCards();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processCards);
  } else {
    processCards();
  }

  new MutationObserver(scheduleProcess).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
